<template>
    <div class="main-layout">
        <site-header />
        <div class="purchased-course">
            <el-tabs v-model="activeTab" @tab-click="handleTabChange" class="custom-tabs">
                <el-tab-pane label="档案课程" name="xueshi"></el-tab-pane>
                <el-tab-pane label="选学课程" name="xuanxue"></el-tab-pane>
            </el-tabs>
            <div class="progress-exam-bar">
                <el-button type="success" :disabled="!canGoToExam" @click="handleGoToExam">去考试</el-button>
                <div class="learn-progress-bar" v-if="learnProgressData">
                    <div class="progress-label">
                        <!-- 学习进度：{{ learnProgressData.learnProgress || 0 }}% -->
                        <span v-if="learnProgressData.time" class="progress-time">已学：{{ learnProgressData.time
                            }}</span>
                    </div>
                    <el-progress :percentage="parseFloat(learnProgressData.learnProgress || 0)" :stroke-width="12"
                        color="#409EFF" style="width: 140px" />
                </div>
            </div>
            <div class="course-list">
                <el-row :gutter="30">
                    <el-col :span="8" v-for="(item, index) in courses"
                        :key="`${activeTab}-${item.courseId || item.materialId}-${index}`">
                        <el-card class="course-card" :class="{ 'selected-card': selectedCourseId === item.courseId }"
                            shadow="hover" @click="selectCourse(item)">
                            <div class="radio-circle" @click.stop="selectCourse(item)">
                                <span v-if="selectedCourseId === item.courseId" class="radio-checked">✔</span>
                            </div>
                            <div class="img-wrap">
                                <img :src="item.imageUrl" alt="课程图片" />
                            </div>
                            <div class="course-info">
                                <div class="course-title">{{ item.name }}</div>
                                <div class="course-desc">
                                    {{ item.validityText }}
                                    <span v-if="item.yearEndTime">
                                        <span v-if="Number(item.yearEndTime) < new Date().getFullYear()">已过期</span>
                                        <span v-else>{{ item.yearEndTime + '年度' }}</span>
                                    </span>
                                </div>
                                <div class="course-price">课程价格：<span>￥{{ item.coursePrice || item.price }}</span></div>
                                <el-button type="primary" class="buy-btn"
                                    @click.stop="goToCourseDetail(item)">进入学习</el-button>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-pagination v-if="total > pageSize" :current-page="pageNum" :page-size="pageSize" :total="total"
                    @current-change="handlePageChange" layout="prev, pager, next" class="custom-pagination" />
            </div>
        </div>
        <ExamDrawer v-if="selectedExamCourseId" :visible.sync="examDrawerVisible" :courseId="selectedExamCourseId" :majorId="selectedExamMajorId"
            :level="selectedExamLevel" :direction="selectedExamDirection" :province="selectedExamProvince"
            @close="examDrawerVisible = false" />
        <site-footer />
    </div>
</template>

<script>
import { CourseList, resourceList } from '@/api/course'
import { getLearnProgress } from '@/api/course'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import ExamDrawer from '@/components/home/ExamDrawer.vue'

export default {
    name: 'PurchasedCourse',
    components: {
        SiteHeader,
        SiteFooter,
        ExamDrawer
    },
    data() {
        return {
            activeTab: 'xueshi',
            courses: [],
            pageNum: 1,
            pageSize: 24,
            total: 0,
            examDrawerVisible: false,
            selectedExamCourseId: null,
            selectedExamMajorId: '',
            selectedExamLevel: '',
            selectedExamDirection: '',
            selectedExamProvince: '',
            allCourses: [],
            selectedCourseId: null,
            learnProgressData: null
        }
    },
    computed: {
        canGoToExam() {
            return (
                this.selectedCourseId &&
                this.learnProgressData &&
                parseFloat(this.learnProgressData.learnProgress || 0) >= 90
            )
        }
    },
    created() {
        this.fetchCourses()
    },
    methods: {
        handleTabChange() {
            this.pageNum = 1
            this.fetchCourses()
        },
        handlePageChange(page) {
            this.pageNum = page
            this.fetchCourses()
        },
        async goToCourseDetail(course) {
            try {
                if (this.activeTab === 'xuanxue' && (course.ossUrl || course.originalUrl)) {
                    // 跳转到视频播放页面
                    this.$router.push({
                        path: '/home/videoPlayer',
                        query: {
                            videoUrl: course.ossUrl || course.originalUrl,
                            title: course.name
                        }
                    });
                    return;
                }
                // 直接使用当前课程的数据
                const courseDetail = course;
                console.log('当前课程数据:', courseDetail);

                // 确保 layout 数据存在
                if (!courseDetail.layout) {
                    console.warn('课程详情中没有 layout 数据');
                }

                // 跳转到 StudyCourse 页面
                const majorData = {
                    layout: courseDetail.layout,
                    courseDetail: courseDetail
                };
                console.log('准备传递的数据:', majorData);

                this.$router.push({
                    path: '/home/studyCourse',
                    query: {
                        courseId: course.courseId,
                        majorData: encodeURIComponent(JSON.stringify(majorData)),
                        province: course.province,
                        level: course.courseLevel,
                        direction: course.courseDirection
                    }
                });
            } catch (error) {
                console.error('跳转失败:', error);
                this.$message.error(error.message || '跳转失败，请稍后重试');
            }
        },
        fetchCourses() {
            const params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }

            if (this.activeTab === 'xueshi') {
                // 学时课程带上 courseType=2
                // params.courseType = 2
                params.deptId = 4 // 固定传4
                console.log('请求学时课程参数:', params)
                CourseList(params).then(res => {
                    console.log('学时课程响应:', res)
                    if (res.code === 200) {
                        this.courses = (res.rows || []).map(item => ({
                            ...item,
                            courseId: item.courseId,
                            layout: item.layout || []
                        }))
                        this.total = res.total || 0
                        if (this.courses.length === 0) {
                            this.$message.info('暂无已购买的课程')
                        }
                    } else {
                        this.$message.error(res.msg || '获取课程列表失败')
                    }
                }).catch(err => {
                    console.error('获取学时课程失败:', err)
                    this.$message.error('获取课程列表失败，请稍后重试')
                })
            } else {
                // 选学课程带上 materialType=2
                params.materialType = 2
                console.log('请求选学课程参数:', params)
                resourceList(params).then(res => {
                    console.log('选学课程响应:', res)
                    if (res.code === 200) {
                        this.courses = (res.rows || []).map(item => ({
                            courseId: item.materialId,
                            name: item.name,
                            imageUrl: item.imageUrl,
                            coursePrice: item.price,
                            validityText: item.validity ? item.validity + '天' : '',
                            createTime: item.createTime,
                            remarks: item.remarks,
                            layout: item.layout || [],
                            courseLevel: item.courseLevel,
                            courseDirection: item.courseDirection,
                            ossUrl: item.ossUrl,
                            originalUrl: item.originalUrl
                        }))
                        this.total = res.total || 0
                        if (this.courses.length === 0) {
                            this.$message.info('暂无已购买的课程')
                        }
                    } else {
                        this.$message.error(res.msg || '获取课程列表失败')
                    }
                }).catch(err => {
                    console.error('获取选学课程失败:', err)
                    this.$message.error('获取课程列表失败，请稍后重试')
                })
            }
        },
        selectCourse(course) {
            this.selectedCourseId = course.courseId
            // 获取学习进度
            const majorId = course.majorId || ''
            const courseId = course.courseId
            if (majorId && courseId) {
                getLearnProgress({ majorId, courseId }).then(res => {
                    if (res.code === 200) {
                        this.learnProgressData = res.data
                    } else {
                        this.learnProgressData = null
                    }
                }).catch(() => {
                    this.learnProgressData = null
                })
            } else {
                this.learnProgressData = null
            }
        },
        handleGoToExam() {
            // 直接用当前选中课程信息打开考试抽屉
            const selected = this.courses.find(c => c.courseId === this.selectedCourseId)
            if (!selected) return
            this.selectedExamCourseId = selected.courseId
            this.selectedExamMajorId = selected.majorId || ''
            this.selectedExamLevel = selected.courseLevel || ''
            this.selectedExamDirection = selected.courseDirection || ''
            this.selectedExamProvince = selected.province || ''
            this.examDrawerVisible = true
        }
    }
}
</script>

<style scoped>
.main-layout {
    min-height: 100vh;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
}

.purchased-course {
    flex: 1;
    padding: 40px;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
}

.custom-tabs {
    margin-bottom: 40px;
    background: transparent;
    padding: 0;
}

.custom-tabs :deep(.el-tabs__header) {
    margin: 0;
    border-bottom: none;
}

.custom-tabs :deep(.el-tabs__nav-wrap) {
    margin-bottom: 0;
}

.custom-tabs :deep(.el-tabs__nav-wrap::after) {
    display: none;
}

.custom-tabs :deep(.el-tabs__nav) {
    display: inline-flex;
    background: #39496f;
    padding: 6px;
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 rgba(57, 73, 111, 0.1), 0 1px 2px 0 rgba(57, 73, 111, 0.06);
}

.custom-tabs :deep(.el-tabs__item) {
    font-size: 16px;
    height: 46px;
    line-height: 46px;
    color: rgba(255, 255, 255, 0.7) !important;
    transition: all 0.3s ease;
    padding: 0 32px;
    border-radius: 8px;
    margin: 0 2px;
}

.custom-tabs :deep(.el-tabs__item:hover) {
    color: #ffffff !important;
}

.custom-tabs :deep(.el-tabs__item.is-active) {
    font-weight: 600;
    color: #39496f !important;
    background: #ffffff;
}

.custom-tabs :deep(.el-tabs__active-bar) {
    display: none !important;
}

.course-list {
    margin-top: 20px;
}

.course-card {
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    min-height: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border: 1px solid #edf2f7;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    position: relative;
}

.course-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px -20px rgba(0, 0, 0, 0.15);
    border-color: #e2e8f0;
}

.img-wrap {
    width: 100%;
    height: 180px;
    background: linear-gradient(to bottom, #f8fafc, #f1f5f9);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}

.img-wrap::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, rgba(255, 255, 255, 0.9), transparent);
}

.img-wrap img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.course-card:hover .img-wrap img {
    transform: scale(1.05);
}

.course-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 24px 20px 20px;
    background: white;
    position: relative;
}

.course-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a202c;
    margin-bottom: 12px;
    text-align: center;
    min-height: 48px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.course-desc {
    color: #718096;
    font-size: 14px;
    margin-bottom: 16px;
    text-align: center;
    line-height: 1.5;
}

.course-price {
    color: #e53e3e;
    font-size: 15px;
    margin-bottom: 20px;
    font-weight: 500;
    background: #fff5f5;
    padding: 6px 16px;
    border-radius: 20px;
}

.course-price span {
    font-size: 24px;
    font-weight: bold;
    margin-left: 4px;
}

.buy-btn {
    width: 85%;
    height: 44px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 2px;
    margin-bottom: 10px;
    transition: all 0.3s;
    background: linear-gradient(135deg, #3182ce, #2c5282);
    border: none;
    color: white;
    position: relative;
    overflow: hidden;
}

.buy-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent);
    transition: 0.5s;
}

.buy-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(49, 130, 206, 0.3);
}

.buy-btn:hover::before {
    left: 100%;
}

.custom-pagination {
    margin-top: 40px;
    text-align: center;
    padding: 20px 0;
}

@media (max-width: 1200px) {
    .purchased-course {
        padding: 20px;
    }
}

@media (max-width: 768px) {
    .el-col {
        width: 100% !important;
    }

    .course-card {
        margin-bottom: 20px;
    }
}

.selected-card {
    border: 2px solid #409EFF !important;
    box-shadow: 0 0 10px #409EFF33;
}

.radio-circle {
    position: absolute;
    top: 14px;
    left: 14px;
    width: 26px;
    height: 26px;
    border: 2px solid #409EFF;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    font-size: 18px;
    color: #409EFF;
    cursor: pointer;
    transition: border-color 0.2s;
}

.radio-circle:hover {
    border-color: #1867c0;
}

.radio-checked {
    font-size: 18px;
    color: #409EFF;
    line-height: 1;
}

.progress-exam-bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 18px;
    margin-bottom: 20px;
    padding: 0 2px;
}

.learn-progress-bar {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
}

.progress-label {
    font-size: 15px;
    color: #39496f;
    margin-bottom: 4px;
}

.progress-time {
    color: #888;
    font-size: 13px;
    margin-left: 8px;
}
</style>